// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"362":"eca78e2e","726":"593106d2","787":"b45b0b57"}[chunkId] + ".chunk.js";
};